import { Modal } from "@mjjs/ui";
import jobPostCaterAPI from "@frontend/app/api/JobPostCaterAPI.ts";
import React from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (newCater: { _id: string; company: string; position: string }) => void;
};

const NewCaterModal = ({ onSuccess, onClose, ...rest }: Props) => {
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    
    const company = e.currentTarget.elements.namedItem("company")?.value;
    const position = e.currentTarget.elements.namedItem("position")?.value;

    if (!company || !position) {
      setError("Company and position are required");
      setLoading(false);
      return;
    }
    
    try {
      const res = await jobPostCaterAPI.create({ company, position });
      onSuccess(res);
      setLoading(false);
    } catch (err: any) {
      console.error("Error creating cater:", err);
      if (err?.response?.status === 401) {
        setError("Authentication expired. Please refresh the page and try again.");
        // The axios interceptor will handle the redirect to login
      } else {
        setError(err instanceof Error ? err.message : "Failed to create cater");
        setLoading(false);
      }
    }
  };

  return (
    <Modal {...rest} onClose={onClose}>
      <h1>New Job Cater</h1>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <form onSubmit={handleSubmit}>
        <label>
          Company
          <input type="text" name="company" disabled={loading} />
        </label>
        <label>
          Position
          <input type="text" name="position" disabled={loading} />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Save"}
        </button>
      </form>
    </Modal>
  );
};

export default NewCaterModal;
